// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BookingController from "./booking_controller"
application.register("booking", BookingController)

import BookingRestorationController from "./booking_restoration_controller"
application.register("booking-restoration", BookingRestorationController)

import BookingSearchController from "./booking_search_controller"
application.register("booking-search", BookingSearchController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CliTokenLifetimeController from "./cli_token_lifetime_controller"
application.register("cli-token-lifetime", CliTokenLifetimeController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmailPreviewController from "./email_preview_controller"
application.register("email-preview", EmailPreviewController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import EmailCheckerController from "./email_checker_controller"
application.register("email-checker", EmailCheckerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HoldTimerController from "./hold_timer_controller"
application.register("hold-timer", HoldTimerController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import InvoiceLinesController from "./invoice_lines_controller"
application.register("invoice-lines", InvoiceLinesController)

import ImportedBookingFormController from "./imported_booking_form_controller"
application.register("imported-booking-form", ImportedBookingFormController)

import LocationApprovalController from "./location_approval_controller"
application.register("location-approval", LocationApprovalController)

import LocationLookupController from "./location_lookup_controller"
application.register("location-lookup", LocationLookupController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavscrollController from "./navscroll_controller"
application.register("navscroll", NavscrollController)

import RefundAmountController from "./refund_amount_controller"
application.register("refund-amount", RefundAmountController)

import RouteMapController from "./route_map_controller"
application.register("route-map", RouteMapController)

import OnepasswordSaveController from "./onepassword_save_controller"
application.register("onepassword-save", OnepasswordSaveController)

import SecretController from "./secret_controller"
application.register("secret", SecretController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StumblingStoneScannerController from "./stumbling_stone_scanner_controller"
application.register("stumbling-stone-scanner", StumblingStoneScannerController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
